export default "__VITE_ASSET__Cdt9C_Wg__"